"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetSlipCheckOptions = void 0;
var BetSlipCheckOptions;
(function (BetSlipCheckOptions) {
    BetSlipCheckOptions[BetSlipCheckOptions["None"] = 0] = "None";
    BetSlipCheckOptions[BetSlipCheckOptions["ExecuteOnCheckBetSlip"] = 1] = "ExecuteOnCheckBetSlip";
    BetSlipCheckOptions[BetSlipCheckOptions["ExecuteBeforePlaceBetSlip"] = 2] = "ExecuteBeforePlaceBetSlip";
    BetSlipCheckOptions[BetSlipCheckOptions["ExecuteAfterPlaceBetSlip"] = 4] = "ExecuteAfterPlaceBetSlip";
    BetSlipCheckOptions[BetSlipCheckOptions["ExecuteBeforeCancelBetSlip"] = 8] = "ExecuteBeforeCancelBetSlip";
    BetSlipCheckOptions[BetSlipCheckOptions["ExecuteAfterCancelBetSlip"] = 16] = "ExecuteAfterCancelBetSlip";
    BetSlipCheckOptions[BetSlipCheckOptions["ExecuteBeforePayBetSlip"] = 32] = "ExecuteBeforePayBetSlip";
    BetSlipCheckOptions[BetSlipCheckOptions["ExecuteAfterPayBetSlip"] = 64] = "ExecuteAfterPayBetSlip";
    BetSlipCheckOptions[BetSlipCheckOptions["OverrideLiveBetSlipPlaceDelay"] = 128] = "OverrideLiveBetSlipPlaceDelay";
})(BetSlipCheckOptions = exports.BetSlipCheckOptions || (exports.BetSlipCheckOptions = {}));
